import type { SoundVoice } from "./contracts";
import { VoiceCatalogToggleDialog } from "./VoiceCatalogToggleDialog";

type EnableVoiceDialogProps = {
  environment: "staging" | "stg";
  voice: SoundVoice;
};

export function EnableVoiceDialog({
  environment,
  voice,
}: EnableVoiceDialogProps) {
  return (
    <VoiceCatalogToggleDialog
      environment={environment}
      mode="enable"
      voice={voice}
    />
  );
}
